module.exports = __webpack_public_path__ + "static/img/home_icon_hzhb.b4c530b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_icon_hzhb.png
// module id = Lh9R
// module chunks = 2